import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { interceptingHandler } from '@angular/common/http/src/module';

export interface Word {
  value: string;
  synonyms: string[];
}

export interface Entities {
  automatedExpansion: boolean;
  entries: Word[];
  id: string;
  isEnum: boolean;
  isOverridable: boolean;
  name: string;
}

@Injectable()
export class DialogflowService {
  entities$: Observable<Entities>;

  constructor(private http: HttpClient) {
    this.entities$ = this.getEntities();
  }

  getEntities() {
    const options = {
      headers: new HttpHeaders({ Authorization: `Bearer ${environment.dialogFlow.token}`}),
    };
    return this.http.get(`https://api.dialogflow.com/v1/entities/${environment.dialogFlow.entityId}`, options)
      .map(x => <Entities>x);
  }
}



// WEBPACK FOOTER //
// /Users/shwld/project/shwld/home-counter/app_src/src/app/shared/services/dialogflow.service.ts